import { Check } from '@phosphor-icons/react';
import { withMagneticIcon } from '../withMagneticIcon.js';

const Icon = withMagneticIcon(Check);
Icon.displayName = "Check";

export { Icon as Check };
//# sourceMappingURL=Check.js.map
